export type FlashSeverity = "warning" | "success"

export type FlashKey = "alert" | "notice"

// Mirrors SharedFlash::FLASH_KEYS (app/controllers/concerns/shared_flash.rb):
// those are the only keys the server ever shares.
export interface IFlash {
    alert?: string | null
    notice?: string | null
}

export interface IFlashMessage {
    key: FlashKey
    severity: FlashSeverity
    text: string
}

// Declaration order is the on-screen order: an alert reports an action that
// only half succeeded, so it goes first.
const FLASH_SEVERITIES: ReadonlyArray<{ key: FlashKey; severity: FlashSeverity }> = [
    { key: "alert", severity: "warning" },
    { key: "notice", severity: "success" },
]

export const flashMessages = (flash?: IFlash | null): IFlashMessage[] =>
    FLASH_SEVERITIES.flatMap(({ key, severity }) => {
        const text = flash?.[key]?.trim()
        return text ? [{ key, severity, text }] : []
    })

// Identity of the flash currently in the page props. Inertia keeps the layout
// mounted across visits, so the consumer has to re-open on a change of this
// value rather than on mount, otherwise only the very first warning is shown.
export const flashSignature = (flash?: IFlash | null): string =>
    flashMessages(flash).map(m => `${m.key}:${m.text}`).join("\n")

// A warning means a change reached the database but not ADM Cloud, and the
// operator has to act on it, so it waits to be dismissed.
export const flashAutoHideMs = (severity: FlashSeverity): number | null =>
    severity === "success" ? 6000 : null
